import React from "react";
import icon1 from "../../icons/icon_dollar.svg";
import icon2 from "../../icons/icon_chart.svg";
import icon3 from "../../icons/icon_gift.svg";
import shape1 from "../../images/about/reward-section.png";
import shape3 from "../../images/shapes/shape_poligon.svg";

const features = [
  
  {
    icon: icon3,
    title: "Important Notice",
    description:
      // "TopCoin UK is a loyalty and rewards programme. It is not an investment or financial product.",
      <div>
        <p className="mb-0">TopCoin UK operates as a loyalty and promotional rewards programme.</p>
        <p className="mb-0">TopCoin is not money, not an investment, and not a financial product.</p>
        <p className="mb-0">TopCoin cannot be purchased and does not provide ownership, profit rights, or financial returns.</p>
        <p className="mb-0">All rewards are promotional in nature and subject to programme conditions.</p>
      </div> 
  },
  // {
  //   icon: icon3,
  //   title: "Provide transparency at every step of your rewards journey",
  //   description:
  //     "When your friends or family want to send their units, they simply add your referral number at the end of theirs, along with the product number.",
  // },
];

const FeaturesSection = () => {
  return (
    <section className="ico_feature_section section_space section_decoration">
      <div className="container">
        <div className="row align-items-center justify-content-center">
          <div className="col-lg-10">
            <div
              className="ico_heading_block text-center"
              data-aos="fade-up"
              data-aos-duration="600"
            >
              {/* <h5 className="text-uppercase fw-light">
                Start sharing today and watch your TopCoin grow!
              </h5> */}
              <h2 className="heading_text mb-0">
                TopCoin UK is here to reward you! Here’s how you can increase
                your TopCoin easily
              </h2>
              <p>
                The more you share, the more TopCoin you can collect, no
                investment, just simple rewards for spreading the word.
              </p>
            </div>
          </div>
        </div>
        <div className="row align-items-center justify-content-lg-between">
          {/* Left Side - Features List */}
          <div className="col-lg-7">
            <ul className="ico_features_group unordered_list_block">
              {features.map((feature, index) => (
                <li
                  key={index}
                  data-aos="fade-up"
                  data-aos-duration="600"
                  data-aos-delay={`${(index + 1) * 100}`}
                >
                  <div className="ico_iconbox_icon_left">
                    <div className="iconbox_icon">
                      <img src={feature.icon} alt={`Icon ${feature.title}`} />
                    </div>
                    <div className="iconbox_info">
                      <h3 className="iconbox_title">{feature.title}</h3>
                      <p className="iconbox_description text-dark opacity-50 fw-light mb-0">
                        {feature.description}
                      </p>
                    </div>
                  </div>
                </li>
              ))}
            </ul>
          </div>

          {/* Right Side - Investment Details */}
          <div className="col-lg-5">
            <img src={shape1} alt="" />
          </div>
        </div>
      </div>

      {/* Decorations */}
      <div className="decoration_item shape_shadow_1">
        <img src={shape3} alt="Shape Color Shadow" />
      </div>
      <div className="decoration_item shape_shadow_2">
        <img src={shape3} alt="Shape Color Shadow" />
      </div>
    </section>
  );
};

export default FeaturesSection;
